module.exports = __webpack_public_path__ + "static/media/cc_icon-visa.5052f637.svg";